import * as ActionTypes from '../actions/CallsActions';
import _ from 'lodash';
import cogoToast from 'cogo-toast';
import { transformMessagesFromServer } from '../helpers/normalize_data';
import { isGoodCall, isBadCall } from '../helpers/call_helpers';

export const calls = (
  state = {
    allCalls: [],
    keyMomentTypes: [],
    visibleCall: null,
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.GET_ALL_CALLS_SUCCESS:
      const newCalls = _.concat(state.allCalls.slice(0, action.offset), action.calls);
      // console.log(newCalls.map((call) => call.summary.time_partition_summary));
      return {
        ...state,
        allCalls: newCalls.map((call) => ({
          ...call,
          is_good_call: isGoodCall(call),
          is_bad_call: isBadCall(call),
        })),
      };

    case ActionTypes.GET_ALL_CALLS_FAILURE:
      return {
        ...state,
      };

    case ActionTypes.GET_CALL_REQUEST:
      return {
        ...state,
        visibleCall: action.id === _.get(state.visibleCall, 'summary.id') ? state.visibleCall : null,
      };

    case ActionTypes.GET_CALL_SUCCESS:
    case ActionTypes.UPDATE_CALL_SUCCESS:
      const transformedMessages = transformMessagesFromServer(action.call.messages);
      const groupedMessages = [];
      transformedMessages.forEach((msg) => {
        const newSpeaker = _.get(_.last(groupedMessages), '0.speaker.name') !== msg.speaker?.name;
        newSpeaker ? groupedMessages.push([msg]) : groupedMessages[groupedMessages.length - 1].push(msg);
      });
      return {
        ...state,
        visibleCall: {
          ...action.call,
          repName: _.get(
            _.find(action.call.participants, (p) => p.speaker_type === 'rep'),
            'name',
            'Unknown Rep'
          ),
          messages: transformedMessages,
          groupedMessages,
          moments: action.call.moments?.map((moment) => ({
            ...moment,
            // end_time: moment.start_time + 180, // For testing specific widths
          })),
        },
        allCalls: state.allCalls.map((call) =>
          call.id === action.call.id
            ? {
                ...call, // In case we have augmented data, leave those fields intact
                ...action.call,
              }
            : call
        ),
      };

    case ActionTypes.GET_KEY_MOMENT_TYPES_SUCCESS:
      return {
        ...state,
        keyMomentTypes: action.types,
      };

    case ActionTypes.DELETE_CALL_REQUEST:
      return {
        ...state,
        allCalls: _.filter(state.allCalls, (call) => call.id !== action.call.id),
      };
    case ActionTypes.DELETE_CALL_SUCCESS:
      cogoToast.success(`Successfully deleted call.`);
      return {
        ...state,
      };

    case ActionTypes.DELETE_CALL_FAILURE:
      cogoToast.error(`There was an error deleting this call, please try again.`);
      return {
        ...state,
        allCalls: [...state.allCalls, action.call],
      };

    case ActionTypes.UPDATE_CHAT_PARTICIPANT_SUCCESS:
      return {
        ...state,
        visibleCall:
          state.visibleCall?.id === action.participant.chat
            ? {
                ...state.visibleCall,
                participants: state.visibleCall.participants?.map((p) => (p.id === action.participant.id ? action.participant : p)),
              }
            : state.visibleCall,
        allCalls: state.allCalls.map((chat) =>
          chat.id === action.participant.chat
            ? {
                ...chat, // In case we have augmented data, leave those fields intact
                participants: chat.participants?.map((p) => (p.id === action.participant.id ? action.participant : p)),
              }
            : chat
        ),
      };
    case ActionTypes.UPDATE_CHAT_PARTICIPANT_FAILURE:
      cogoToast.error(`There was an error updating the participants, please try again.`);
      return {
        ...state,
      };

    default:
      return state;
  }
};
